export default {
      id: "youtube-usage",
      viewBox: "0 0 48 48",
      url: "/assets/" + "icons.svg#youtube",
      toString: function () {
        return this.url;
      }
    }